import { useQuery } from '@tanstack/react-query';

import type { DtoV1AUSGetAusDetailsResponse } from '~/__generated__/api';
import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';

import { validateObfuscatedIdentifier } from './ausDetailsValidator';

type AusDetailsResponse = DtoV1AUSGetAusDetailsResponse;

type UseAUSDetailsQueryOptions = {
  enabled?: boolean;
};

export function useAUSDetailsQuery({
  enabled = true,
}: Readonly<UseAUSDetailsQueryOptions> = {}) {
  const { obfuscatedLoanIdentifier } = useUrl();
  const hasObfuscatedIdentifiers =
    obfuscatedLoanIdentifier?.obfuscatedLenderDatabaseId !== undefined &&
    obfuscatedLoanIdentifier?.obfuscatedLoanRecordId !== undefined;

  return useQuery<AusDetailsResponse>({
    queryKey: [
      'ausDetails',
      obfuscatedLoanIdentifier?.obfuscatedLenderDatabaseId,
      obfuscatedLoanIdentifier?.obfuscatedLoanRecordId,
    ],
    enabled: enabled && hasObfuscatedIdentifiers,
    async queryFn() {
      validateObfuscatedIdentifier(obfuscatedLoanIdentifier);
      const { obfuscatedLenderDatabaseId, obfuscatedLoanRecordId } =
        obfuscatedLoanIdentifier;
      const { data } = await typedApiClient.v1.ausAusDetailsList(
        obfuscatedLenderDatabaseId,
        obfuscatedLoanRecordId,
      );
      return data;
    },
  });
}
